import { HttpParams, httpResource } from '@angular/common/http';
import { computed, runInInjectionContext } from '@angular/core';
import { widgetHttpHeader } from 'scw-digital-boards-widgets';
import { oeeContext } from '../../../../core/interceptors/api-interceptor.interceptor';
import { IJob } from '../../../../pages/dashboard-content/widget-add-edit-dialog/widget-add-edit-dialog.interface';
import { IBaseResponse } from '../../../../utilities/http-utilities.service';
import { AdvancedFilterApiMatcher } from './advanced-filter-api-matcher';

export class JobAdvancedFilterApiMatcher extends AdvancedFilterApiMatcher {
  public override idValidationResource = runInInjectionContext(this.injector, () =>
    httpResource<IBaseResponse<IJob>>(() => ({
      context: oeeContext,
      headers: widgetHttpHeader,
      method: 'GET',
      params: new HttpParams().set('fields', 'id,name,siteId'),
      reportProgress: true,
      url: `jobs/${this.id}`,
    })),
  );
  public override label = computed(() => {
    return this.idValidationResource.status() === 'resolved'
      ? (this.idValidationResource.value()?.data.jobName ?? '...')
      : '...';
  });
}
